import { useEffect } from 'react';
import { useAuth } from '@frontegg/react';
import useAccount from '@elementary/common-ui/hooks/useAccount';
import { useRecoilState } from 'recoil';
import * as atoms from 'shared/store/atoms';

const useIsBoomiLookEnabled = () => {
  const { user } = useAuth();
  const { data: account } = useAccount();
  const [savedBoomiLook, setSavedBoomiLook] = useRecoilState(
    atoms.accountBoomiLook,
  );
  const accountId = account?.id;
  const isAccountBoomiLookEnabled = Boolean(account?.boomi_look_enabled);

  useEffect(() => {
    if (accountId) {
      setSavedBoomiLook({
        accountId,
        isBoomiLookEnabled: isAccountBoomiLookEnabled,
      });
    }
  }, [accountId, isAccountBoomiLookEnabled, setSavedBoomiLook]);

  if (account) {
    return isAccountBoomiLookEnabled;
  }
  return Boolean(
    user?.tenantId &&
      savedBoomiLook?.accountId === user.tenantId &&
      savedBoomiLook.isBoomiLookEnabled,
  );
};

export default useIsBoomiLookEnabled;
